import { debounce, isDesktop } from 'assets/core/js/common'
import ElementPropertiesManager from 'assets/core/js/module/element-properties-manager'
import ImagesSlider from 'assets/core/js/module/images-slider'
import { PartialsEvents } from 'assets/core/js/module/partials-manager'
import { initZoomMediasPanel } from 'assets/core/js/page/product/zoom-medias-panel'
import type { Slider } from '@ui/Slider/component'

const initResultsSliders = function (): void {
  const initSlider = (el: HTMLElement): void => {
    ImagesSlider(el, {
      navigation: {
        nextEl: el.querySelector<HTMLElement>('.slider-button-next'),
        prevEl: el.querySelector<HTMLElement>('.slider-button-prev'),
      },
      pagination: {
        el: el.querySelector<HTMLElement>('.slider-pagination'),
        type: 'custom',
        renderCustom: function (current: number, total: number) {
          return `${current}/${total}`
        },
      },
      spaceBetween: 10,
    })
  }

  if (isDesktop()) {
    document.querySelectorAll<HTMLElement>('.result__image .slider').forEach(function (el): void {
      if (!el) {
        return
      }

      initSlider(el)
    })
  }

  const resizeFn = debounce(100, () => {
    document.querySelectorAll<HTMLElement>('.result__image .slider').forEach((el) => {
      const slider = ElementPropertiesManager.getProperty<Slider>(el, 'slider')

      if (isDesktop() && !slider) {
        initSlider(el)
        window.removeEventListener('resize', resizeFn)
      }
    })
  })

  window.addEventListener('resize', resizeFn)
}

const updateSlidersOnPartialsEvents = function (): void {
  const partialResultsEl = document.querySelector('[data-partial-id="results"]')

  if (partialResultsEl) {
    partialResultsEl.addEventListener(PartialsEvents.PRE_UPDATE, () => {
      document.querySelectorAll<HTMLElement>('.result__image .slider').forEach((el) => {
        const slider = ElementPropertiesManager.getProperty<Slider>(el, 'slider')

        if (slider) {
          slider.destroy()
        }
      })
    })

    partialResultsEl.addEventListener(PartialsEvents.POST_UPDATE, () => {
      initResultsSliders()
    })
  }
}

export default function (): void {
  ImagesSlider(document.getElementById('gallery') as HTMLElement, {
    navigation: {
      prevEl: '#gallery-prev',
      nextEl: '#gallery-next',
    },
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 1000,
  })

  initResultsSliders()
  updateSlidersOnPartialsEvents()

  document.querySelectorAll<HTMLImageElement>('.product__images img').forEach((img) => {
    initZoomMediasPanel(img, true)
  })
}
